import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsThroughputPerOperationTrailerReportComponent } from './fields-interventions-throughput-per-operation-trailer-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsThroughputPerOperationTrailerReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsThroughputPerOperationTrailerReportComponent]
})
export class FieldsInterventionsThroughputPerOperationTrailerReportModule { }
